import React from 'react'
import { TouchableOpacity } from 'react-native'

import PropTypes from 'prop-types'

import { Icon } from '@vfgroup-oneplatform/foundation/Components'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import { Images } from '@vfgroup-oneplatform/framework/Themes'

import style from './CurrentLocationIcon.Styles'

const CurrentLocationIcon = ({ onPress, disabled }) => {
  const theme = useTheme()

  return (
    <TouchableOpacity style={style.container(theme, disabled)} onPress={onPress} disabled={disabled}>
      <Icon size={33} name={Images.icCurrentLocation} />
    </TouchableOpacity>
  )
}
CurrentLocationIcon.propTypes = {
  onPress: PropTypes.func,
  disabled: PropTypes.bool
}
export default CurrentLocationIcon
